import { Stack, Typography } from '@ui-components/neo.tax';
import { ReactElement, useEffect, useState } from 'react';

import { ProjectBadgeConfig } from '@neo.tax/rd/utils';

import {
  StyledConfirmProjectDetailsButton,
  StyledStackBadge,
  StyledTypographyLineClamp,
  StyledTypographyMoreLessLink,
} from './Header.styled';

interface HeaderProps {
  projectBadgeConfig: ProjectBadgeConfig;
  isOpen: boolean;
  description: string;
  showMoreLessLink: boolean;
  showConfirmProjectDetailsLink: boolean;
  onClickConfirmProjectDetails: () => void;
}

export const Header = ({
  description,
  isOpen,
  onClickConfirmProjectDetails,
  projectBadgeConfig,
  showConfirmProjectDetailsLink,
  showMoreLessLink,
}: HeaderProps): ReactElement => {
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);

  // Reset description expansion when description changes
  useEffect(() => {
    setIsDescriptionExpanded(false);
  }, [description]);

  return (
    <StyledStackBadge
      $colorVariant={projectBadgeConfig.colorVariant}
      alignItems="flex-start"
      $isOpen={isOpen}
      gap={2}
      paddingX={3}
      paddingY={3}
      direction="column"
    >
      <Stack direction="row" gap={2}>
        <Typography fontSize="sm" fontWeight="medium" color="inherit">
          AI Guidance:
        </Typography>
        <Typography fontSize="sm" fontWeight="medium" color="inherit">
          {projectBadgeConfig.label}
        </Typography>
      </Stack>

      <Stack direction="column" gap={0}>
        <StyledTypographyLineClamp
          fontSize="xs"
          fontWeight="normal"
          color="inherit"
          $numOfLines={3}
          $isExpanded={isDescriptionExpanded}
        >
          {description}
        </StyledTypographyLineClamp>
        {showMoreLessLink && (
          <StyledTypographyMoreLessLink
            fontSize="xs"
            fontWeight="normal"
            color="inherit"
            onClick={() => {
              setIsDescriptionExpanded(!isDescriptionExpanded);
            }}
          >
            {isDescriptionExpanded ? 'Hide details' : 'Read more'}
          </StyledTypographyMoreLessLink>
        )}

        {showConfirmProjectDetailsLink && (
          <StyledConfirmProjectDetailsButton
            variant="primary"
            size="sm"
            rounded="regular"
            onClick={onClickConfirmProjectDetails}
          >
            Confirm Project Details
          </StyledConfirmProjectDetailsButton>
        )}
      </Stack>
    </StyledStackBadge>
  );
};
